import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ApiMetrics } from 'client/utils/metrics-hoc';
import { fireSubmitTracking } from 'site-modules/shared/utils/inventory/global-search-tracking';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';
import convexMaskMobile from 'site-modules/shared/components/clipped-container/mask-library/home-header-mobile';
import convexMaskDesktop from 'site-modules/shared/components/clipped-container/mask-library/convex-header';
import { ClippedContainer } from 'site-modules/shared/components/clipped-container/clipped-container';
import { PERSONALIZED_CREATIVE_ID } from 'site-modules/personalized-search/constants/tracking';
import { SEARCH_QUERY_PARAM } from 'site-modules/shared/constants/personalized-search/personalized-search';
import { getQuery } from 'client/utils/location';
import { GlobalSearch } from 'site-modules/shared/components/inventory/global-search/global-search';

import './personalized-search-header.scss';

export const PersonalizedSearchHeader = memo(
  ({
    isMobile = false,
    apiMetrics = undefined,
    input = undefined,
    trapFocus = undefined,
    location,
    searchId = undefined,
  }) => {
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const prevSearchId = usePrevious(searchId);
    const urlQuery = getQuery(location);
    const query = urlQuery[SEARCH_QUERY_PARAM] || input;

    useEffect(() => {
      if (searchId !== prevSearchId && searchId) {
        fireSubmitTracking({
          input: query,
          creativeId: PERSONALIZED_CREATIVE_ID,
          searchId,
        });
      }
      // eslint-disable-next-line
    }, [searchId]);

    return (
      <div className="personalized-search-header pos-r p-0">
        <div className="pos-r px-1">
          <ClippedContainer
            containerClasses="personalized-search-gradient d-flex pos-a left-0 right-0 mobile"
            mask={isMobile ? convexMaskMobile : convexMaskDesktop}
          />

          <div className="mt-0_5">
            <GlobalSearch
              isMobile={isMobile}
              apiMetrics={apiMetrics}
              controlled
              isOpen={isOpenDrawer}
              onChangeOpenState={setIsOpenDrawer}
              creativeId={PERSONALIZED_CREATIVE_ID}
              searchId={searchId}
              trapFocus={trapFocus}
              inputClassname="pe-2_5"
              query={query}
              closeOnResultSelect
              keepClearButtonPermanently
            />
          </div>
        </div>
      </div>
    );
  }
);

PersonalizedSearchHeader.displayName = 'PersonalizedSearchHeader';
PersonalizedSearchHeader.propTypes = {
  apiMetrics: ApiMetrics,
  input: PropTypes.string,
  searchId: PropTypes.string,
  isMobile: PropTypes.bool,
  trapFocus: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
};
